module.exports = __webpack_public_path__ + "img/search.fe370047.svg";